(function installBearWoodsShipAidCart() {
  if (window.__bearWoodsShipAidCart) {
    window.__bearWoodsShipAidCart.reconcile();
    return;
  }

  const script = document.currentScript;
  const currency = script?.dataset.currency || window.Shopify?.currency?.active || 'USD';
  const language = script?.dataset.lang || window.Shopify?.locale || 'en';
  let widget = null;
  let parking = null;
  let timer = null;
  let lastCartSignature = '';
  let autoOptInConfig = null;
  let cartSyncInProgress = false;
  let cartSyncAgain = false;
  let observedCartRoot = null;
  const cartObserver = new MutationObserver(schedule);
  const cartRootObserver = new MutationObserver(function (records) {
    if (observedCartRoot?.isConnected) return;
    const selector = window.theme?.pageType === 'cart' ? '[data-section-type="cart"]' : '#mini-cart';
    if (observedCartRoot || records.some(record => Array.from(record.addedNodes).some(node =>
      node instanceof Element && (node.matches(selector) || node.querySelector(selector))))) schedule();
  });

  function observeCart() {
    const cart = window.theme?.pageType === 'cart'
      ? document.querySelector('[data-section-type="cart"]')
      : document.getElementById('mini-cart');
    // Warehouse replaces cart contents inside these stable ancestors.
    const root = cart?.closest('.header__action-item--cart, [id^="shopify-section-"]') || cart?.parentElement || cart;
    if (root === observedCartRoot) return;
    cartObserver.disconnect();
    observedCartRoot = root;
    if (root) cartObserver.observe(root, { childList: true, subtree: true });
  }

  function reconcile() {
    observeCart();
    if (!document.body || !customElements.get('shipaid-widget')) return;
    if (!widget) {
      widget = document.createElement('shipaid-widget');
      widget.setAttribute('data-bear-woods-shipaid', '');
      widget.setAttribute('disableRefresh', '');
      widget.setAttribute('currency', currency);
      widget.setAttribute('lang', language);
      widget.style.cssText = 'display:block;width:100%;margin:0 0 12px;' +
        '--shipaid-font:var(--text-font-family, sans-serif);' +
        '--shipaid-font-lg:18px;' +
        '--shipaid-font-heavy:var(--text-font-bolder-weight, 600);' +
        '--shipaid-font-xxs:15px;' +
        '--shipaid-prompt-actions-price-fontSize:var(--shipaid-font-lg);' +
        '--shipaid-prompt-actions-price-color:#671113;' +
        '--shipaid-toggle-active:#671113;';
      widget.addEventListener('click', onProtectionChoice, true);
      widget.addEventListener('shipaid:widget:loaded', function (event) {
        if (event.target !== widget) return;
        widget.dataset.bwReady = '';
        autoOptInConfig = event.detail;
        synchronizeCart();
      });
    }

    const checkout = window.theme?.pageType === 'cart'
      ? document.querySelector('[data-section-type="cart"] .cart-recap__checkout')
      : document.querySelector('#mini-cart .mini-cart__button-container');
    if (checkout) {
      const slot = window.theme?.pageType === 'cart' ? checkout.parentElement.querySelector('[data-bw-protection-slot]') : null;
      if (slot) { if (widget.parentElement !== slot) slot.append(widget); }
      else if (widget.nextElementSibling !== checkout) checkout.before(widget);
      styleWidget();
      return;
    }

    // Keep one instance alive so its cart cleanup can run while the cart is empty.
    if (!parking || !parking.isConnected) {
      parking = document.createElement('div');
      parking.hidden = true;
      parking.setAttribute('data-bear-woods-shipaid-parking', '');
      document.body.append(parking);
    }
    if (widget.parentElement !== parking) parking.append(widget);
    styleWidget();
  }

  function styleWidget() {
    const root = widget.shadowRoot;
    if (!root || root.querySelector('[data-bear-woods-shipaid-style]')) return;
    const style = document.createElement('style');
    style.setAttribute('data-bear-woods-shipaid-style', '');
    style.textContent = `
:host { container-type: inline-size; }
:host .shipaid-widget-container { margin: 0 !important; }
:host .shipaid-prompt { padding: 0 !important; }
:host .shipaid-prompt .prompt-product {
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 0;
}
:host .shipaid-prompt .prompt-product .prompt-product-image {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 30px;
  width: 30px;
}
:host .shipaid-prompt .prompt-product .prompt-product-image svg,
:host .shipaid-prompt .prompt-product .prompt-product-image img {
  width: 30px;
  height: 24px;
  max-width: 30px;
  max-height: 24px;
}
:host .shipaid-prompt .prompt-product .prompt-product-details {
  flex: 1;
  min-width: 0;
}
:host .shipaid-prompt .heading-container { margin: 0 0 3px !important; }
:host .shipaid-prompt .prompt-product .prompt-product-details .prompt-product-details-title {
  margin: 0 !important;
  font: 600 18px/1.3 var(--text-font-family, "Barlow Condensed", sans-serif) !important;
}
:host .shipaid-prompt .prompt-product .prompt-product-details .prompt-product-details-description {
  margin: 0 !important;
  font: 400 15px/1.4 var(--text-font-family, "Barlow Condensed", sans-serif) !important;
}
:host .prompt-product-details-subtitle {
  display: flex;
  align-items: center;
  gap: 4px;
  min-width: 0;
  margin: 0 !important;
}
:host .prompt-product-details-help {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 24px;
  min-width: 24px;
  min-height: 24px;
  margin: 0;
}
:host .prompt-product-details-help svg { width: 15px; height: 15px; }
:host .shipaid-prompt .prompt-product .prompt-product-actions {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
}
:host .shipaid-prompt .prompt-product .prompt-product-actions .prompt-product-actions-price {
  margin: 0 !important;
  white-space: nowrap;
  font: 600 16px/1.4 Arial, sans-serif !important;
}
:host .shipaid-prompt .prompt-product .prompt-product-actions .shipaid-checkbox {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 44px;
  width: 44px;
  height: 44px;
}
:host .prompt-product-actions .shipaid-checkbox .shipaid-checkMark {
  position: relative;
  top: auto;
  right: auto;
  display: block;
  box-sizing: border-box;
  width: 22px;
  height: 22px;
  margin: 0;
}
:host .prompt-product-actions .shipaid-checkbox .shipaid-checkMark:after {
  left: 6px;
  top: 2px;
  width: 5px;
  height: 11px;
}
/* Fit narrow cart summaries by their own width, including desktop sidebars. */
@container (max-width: 380px) {
  :host .shipaid-prompt .prompt-product {
    display: grid;
    grid-template-columns: 28px minmax(0, 1fr) auto;
    column-gap: 7px;
    row-gap: 3px;
    align-items: center;
  }
  :host .shipaid-prompt .prompt-product .prompt-product-image {
    grid-column: 1;
    grid-row: 1 / 3;
    width: 28px;
  }
  :host .shipaid-prompt .prompt-product .prompt-product-image svg,
  :host .shipaid-prompt .prompt-product .prompt-product-image img {
    width: 28px;
    height: 22px;
  }
  :host .shipaid-prompt .prompt-product .prompt-product-details { display: contents; }
  :host .shipaid-prompt .heading-container {
    grid-column: 2;
    grid-row: 1;
    align-self: end;
    margin: 0 !important;
  }
  :host .shipaid-prompt .prompt-product .prompt-product-details .prompt-product-details-title {
    font-size: 17px !important;
  }
  :host .prompt-product-details-subtitle {
    grid-column: 2;
    grid-row: 2;
    align-self: start;
    justify-self: start;
  }
  :host .shipaid-prompt .prompt-product .prompt-product-actions {
    grid-column: 3;
    grid-row: 1 / 3;
    gap: 4px;
  }
}
/* Give long currency labels room on the narrowest phone summaries. */
@container (max-width: 280px) {
  :host .prompt-product-details-subtitle {
    grid-column: 2 / -1;
    grid-row: 3;
  }
}
    `;
    // Prepend outside Lit's render range so updates retain the same scoped style.
    root.prepend(style);
  }

  function schedule() {
    if (timer !== null) return;
    timer = setTimeout(function () {
      timer = null;
      reconcile();
    }, 0);
  }

  function onProtectionChoice(event) {
    const input = event.composedPath().find(node => node instanceof HTMLInputElement && node.type === 'checkbox');
    if (!input || input.getRootNode() !== widget.shadowRoot
      || !input.closest('.shipaid-checkbox, .shipaid-toggle')) return;
    // Persist the shopper's choice before V1 performs its normal add/remove action.
    if (typeof widget.setOptOutByCustomer === 'function') widget.setOptOutByCustomer(!input.checked);
  }

  function onShipAidCartUpdated(event) {
    if (event.detail?.data?.source !== 'shipaid-widget') return;
    const cart = event.detail?.cart;
    if (!cart || !Array.isArray(cart.items) || !Number.isFinite(cart.total_price)) return;
    const signature = JSON.stringify({
      items: cart.items.map(item => [item.key, item.quantity, item.final_line_price]),
      total: cart.total_price
    });
    if (signature === lastCartSignature) return;
    lastCartSignature = signature;
    // Warehouse owns the cart lines, total and item count; ask its native renderer.
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
      bubbles: true,
      detail: { scrollToTop: false }
    }));
    schedule();
  }

  function onCartRerendered() {
    reconcile();
    synchronizeCart();
  }

  async function synchronizeCart() {
    if (!widget || typeof widget.updateCart !== 'function') return;
    if (cartSyncInProgress) { cartSyncAgain = true; return; }
    cartSyncInProgress = true;
    try {
      do {
        cartSyncAgain = false;
        await widget.updateCart();
        if (!autoOptInConfig?.planActive || !autoOptInConfig.widgetAutoOptIn || !autoOptInConfig.widgetShowCart) continue;
        if (widget.customerId && autoOptInConfig.excludedCustomersIdsAutoOptIn?.includes(
          'gid://shopify/Customer/' + widget.customerId)) continue;
        // The public quote methods honor product exclusions and prepare the correct fee variant.
        if (typeof widget.updateProtection !== 'function' || typeof widget.calculateProtectionTotal !== 'function'
          || typeof widget.attemptAddProtection !== 'function') continue;
        await widget.updateProtection();
        if (widget.hasProtection?.() || widget.getIsOptOutByCustomer?.()) continue;
        if (!(await widget.calculateProtectionTotal() > 0)) continue;
        // Reuse V1's opt-out, existing-protection and auto-opt-in guards after native cart changes.
        await widget.attemptAddProtection();
      } while (cartSyncAgain);
    } catch {} finally {
      cartSyncInProgress = false;
    }
  }

  function onExternalCartUpdate(event) {
    if (event.detail?.data?.source === 'shipaid-widget') onShipAidCartUpdated(event);
  }

  window.__bearWoodsShipAidCart = { reconcile: schedule };
  document.addEventListener('shipaid:cart:updated', onShipAidCartUpdated);
  // V1's automatic fee variant correction emits cart:update rather than the named event.
  document.addEventListener('cart:update', onExternalCartUpdate);
  window.addEventListener('cart:update', onExternalCartUpdate);
  // Warehouse's mini-cart event does not bubble, so capture it at document level.
  document.addEventListener('cart:rerendered', onCartRerendered, true);
  document.addEventListener('shopify:section:load', schedule);
  window.addEventListener('pageshow', schedule);

  function start() {
    observeCart();
    // A cheap connectivity guard catches third-party ancestor replacements without scanning page changes.
    cartRootObserver.observe(document.documentElement, { childList: true, subtree: true });
    customElements.whenDefined('shipaid-widget').then(schedule);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();


